import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { BaseComponent } from '@shared/components/base/base.component';
import { BaseSharedService } from '@shared/components/base-shared/base-shared.service';
import { NotificationService } from '@core/services/notification.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-detalhe',
  templateUrl: './modal-detalhe.component.html',
  styleUrls: ['./modal-detalhe.component.scss']
})
export class ModalDetalheComponent extends BaseComponent implements OnInit {

  @Input() item: any;

  @Input() lista: any[] = [];
  @Input() index: number = 0;
  @Input() somenteLeitura: boolean = false;

  file: any = {};
  fileForm: FormGroup;

  editouDescricao: boolean = false;

  @HostListener('window:keydown.arrowleft', ['$event'])
  onLeftKey(_event?: Event) {
    this.navegarAnterior();
  }

  @HostListener('window:keydown.arrowright', ['$event'])
  onRightKey(_event?: Event) {
    this.navegarProximo();
  }

  constructor(
    protected modal: NzModalRef,
    protected override modalService: NzModalService,
    protected override notificationService: NotificationService,
    baseSharedService: BaseSharedService
  ) {
    super(baseSharedService);

    this.fileForm = this.fb.group({
      descricao: new FormControl('', [Validators.maxLength(50)]),
      fileName: new FormControl(''),
      url: new FormControl(''),
      id: new FormControl(''),
    });

  }

  ngOnInit() {
    this.atualizarItem();
    if (this.somenteLeitura) {
      this.desativaItens();
    }
  }

  atualizarItem() {
    this.item = this.lista[this.index].id;
    this.carregarDados();
  }

  carregarDados() {
    this.uploadService.consultarPorId(this.item).subscribe({
      next: (val: any) => {
        val.subscribe((base64String: string) => {
          this.file.url = base64String;
          this.fileForm.patchValue({ url: this.file.url });
        });
      }
    });


    this.uploadService.getMetadata(this.item).subscribe({
      next: (metaData: any) => {
        this.fileForm.patchValue({
          descricao: metaData.descricao,
          fileName: metaData.fileName,
          id: this.item,
          url: this.file.url
        });
      }
    });

  }

  desativaItens() {
    this.fileForm.get('descricao')?.disable();
  }

  editarDetalhes() {
    if (this.somenteLeitura) {
      return;
    }

    if (this.fileForm.invalid) {
      this.notificationService.warn('Erro', 'Por favor, preencha todos os campos corretamente.');
      return;
    }

    const objEnvio = {
      'descricao': (this.fileForm.get('descricao')?.value ?? '').trim() || null,
      'id': this.item
    }

    this.uploadService.updateDetalhes(this.item, objEnvio).subscribe({
      next: (val: any) => {
        this.editouDescricao = true;
        this.notificationService.success('Sucesso!', 'Descrição salva com sucesso!');
      }
    });
  }

  override getSanitizedImageSrc(file: any) {
    return (file.url) ? this.sanitizer.bypassSecurityTrustUrl(file.url) : null;
  }

  fecharModal() {
    if (this.editouDescricao) {
      this.modal.destroy({
        id: this.item,
        descricao: (this.fileForm.get('descricao')?.value ?? '').trim() || null
      });
    } else {
      this.modal.destroy();
    }
    this.appSharedDataService.setCloseModal(false);
  }

  navegarAnterior() {
    if (this.index > 0) {
      this.index--;
      this.atualizarItem();
    }
  }

  navegarProximo() {
    if (this.index < this.lista.length - 1) {
      this.index++;
      this.atualizarItem();
    }
  }

}
